import React from 'react'

function StatusText(props) {
  if (props.value === '0') {
    return (<span className="label label-default" >เริ่มต้น</span>);
  } else if (props.value === '1') {
    return (<span className="label label-warning" >อยู่ระหว่างซ่อม</span>);
  } else if (props.value === '2') {
    return (<span className="label label-primary" >รอส่งมอบรถ</span>);
  } else if (props.value === '3') {
    return (<span className="label label-success" >งานเสร็จเรียบร้อย</span>);
  } else if (props.value === '4') {
    return (<span className="label label-danger" >มีปัญหา</span>);
  } else {
    return (<span className="label label-default" >ไม่ทราบสถานะ</span>);
  }

}

export default StatusText


// WEBPACK FOOTER //
// ./src/component/element/StatusText.js